'use strict';

var fuzzyRegExpCache = {};

var join = function join(head, tail) {
  var nTail = tail;
  if (tail.length === 0) {
    nTail = [head];
  } else if (head.end === nTail[0].start) {
    nTail[0].start = head.start;
  } else {
    nTail.unshift(head);
  }
  return nTail;
};

var convertSimple2RegExpPattern = function convertSimple2RegExpPattern(pattern) {
  return pattern.replace(/[\-\\\{\}\+\?\|\^\$\.\,\[\]\(\)\#\s]/g, '\\$&').replace(/[\*]/g, '.*');
};

var matchesSubsString = function matchesSubsString(word, wordToMatchAgainst, i, j) {
  if (i === word.length) {
    return [];
  }

  if (j === wordToMatchAgainst.length) {
    return null;
  }

  if (word[i] === wordToMatchAgainst[j]) {
    var result = matchesSubsString(word, wordToMatchAgainst, i + 1, j + 1);
    if (result) {
      return join({ start: j, end: j + 1 }, result);
    }
  }

  return matchesSubsString(word, wordToMatchAgainst, i, j + 1);
};
var matchesFuzzy = function matchesFuzzy(word, wordToMatchAgainst) {
  var nWord = word;
  if (typeof word !== 'string' || typeof wordToMatchAgainst !== 'string') {
    return null; // return early for invalid input
  }
  nWord = nWord.replace(/-/g, '');
  // Form RegExp for wildcard matches
  var regexp = fuzzyRegExpCache[nWord];
  if (!regexp) {
    regexp = new RegExp(convertSimple2RegExpPattern(nWord), 'i');
    fuzzyRegExpCache[nWord] = regexp;
  }

  // RegExp Filter
  var match = regexp.exec(wordToMatchAgainst);
  if (match) {
    return [{ start: match.index, end: match.index + match[0].length }];
  }

  // Default Filter
  return matchesSubsString(nWord.toLowerCase(), wordToMatchAgainst.toLowerCase(), 0, 0);
};

function wrapWithBold(s, range) {
  var head = s.substring(0, range.start);
  var middle = s.substring(range.start, range.end);
  var tail = s.substring(range.end);
  return head + '<strong>' + middle + '</strong>' + tail;
}

var highlightWords = function highlightWords(wordToChange, highlightList) {
  if (highlightList === null) {
    return wordToChange;
  }
  var nHighlightList = highlightList.reverse().reduce(function (result, range) {
    return wrapWithBold(result, range);
  }, wordToChange);
  return nHighlightList;
};

module.exports = {
  highlightWords: highlightWords,
  matchesFuzzy: matchesFuzzy,
  join: join,
  convertSimple2RegExpPattern: convertSimple2RegExpPattern,
  matchesSubsString: matchesSubsString,
  wrapWithBold: wrapWithBold
};